import React, { useEffect, useRef, useState } from "react";
import styles from "./CattleModal.module.css"
import CloseIcon from "@mui/icons-material/Close";
import { url } from "../../../../../App";
import axios from "axios";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import { MdDeleteForever } from "react-icons/md";
import { IoMdDownload } from "react-icons/io";
import EditIcon from '@mui/icons-material/Edit';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import PreviewModal from "../PreviewModal";
import MultiViewModal from "../MultiViewModal";

const CattleModal = ({ loanId, closeModal }) => {
  const [open, setOpen] = React.useState(false);
  const [cattleVal, setCattleVal] = useState({
    srNo: "",
    NoOfCattle: "",
    TypeofCattle: "",
    Breed: "",
    SumAssured: "",
    RiskStartDate: "",
    RiskEndDate: "",
    RFIDNo: "",
    PolicyNo: "",
    imageFormatPolicy: "",
    imageBase64Policy: "",
    imageFormatCover: "",
    imageBase64Cover: "",
    cattleImages: [],
  });
  const [cattleCount, setCattleCount] = useState(1);
  const [cattleArr, setCattleArr] = useState([]);
  const [isUpdateActive, setIsUpdateActive] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [parentModal, setParentModal] = useState(false);
  const [base64Image, setBase64Image] = useState("");
  const [docType, setDocType] = useState("");
  const [cattleData, setCattleData] = useState([]);

  const fetchData = async () => {
    setOpen(true);
    const req = {
      loanId: loanId,
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
    };
    try {
      const { data } = await axios.post(url + "/loan/view/cattle/data", req);
      if (!data.auth) {
        setOpen(false);
        if (data.message === "No data found.") {
          setCattleArr([]);
          setCattleCount("1")
        }
        return;
      }
      setCattleCount(data.cattleCount);
      setCattleArr(data.data);
      console.log(data.data)
      setOpen(false);
    } catch (error) {
      setOpen(false);
      console.log(error.response.status);
    }
  };

  const onDelete = async (file) => {
    const confirmDelete = window.confirm("Do you want to Delete the Cattle Image?");
    if (!confirmDelete) {
      toast.error("Permission Denied by the user.");
      return false;
    }
  
    try {
      const response = await axios.post(url + "/loan/deleteCattleImages", {
        imageId: file._id,
        loanId: loanId,
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
      });
  
      if (response.data.auth) {
        toast.success(response.data.message);
        return true;
      } else {
        toast.error("Unauthorized or deletion failed.");
        return false;
      }
    } catch (error) {
      console.error("Error deleting document:", error);
      toast.error("Failed to delete document.");
      return false;
    }
  };
  
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const policyRef = useRef(null);
  const coverRef = useRef(null);
  const cattleRef = useRef(null);

  const handleInputChange = (state) => {
    return (e) => {
      setCattleVal((prevState) => ({
        ...prevState,
        [state]: e.target.value,
      }));
    };
  };

  const handleImageUpload = (e, docType) => {
    // console.log("reached")
    // console.log(e)
    const files = e.target.files;
    if (!files || files.length === 0) {
      setOpen(false);
      return;
    }

    const cattleFormats = ["jpg", "jpeg", "png"];
    const policyFormats = ["pdf"];
    const coverFormats = ["pdf"];

    if (docType === "Cattle") {
      const newImages = [];
      const promises = Array.from(files).map((file) => {
        return new Promise((resolve, reject) => {
          const fileExtension = file.name.split(".").pop().toLowerCase();
          if (!cattleFormats.includes(fileExtension)) {
            toast.error("Please upload Cattle Images in jpeg, jpg, or png format only.");
            reject();
            return;
          }

          const reader = new FileReader();
          reader.onload = () => {
            const base64string = reader.result.split(",")[1];
            newImages.push({
              chequeDataCattle: base64string,
              docTypeCattle: fileExtension,
            });
            resolve();
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      });

      Promise.all(promises)
        .then(() => {
          setCattleVal((prevState) => ({
            ...prevState,
            cattleImages: [...prevState.cattleImages, ...newImages],
          }));
          toast.success("Cattle Documents Uploaded Successfully.");
        })
        .catch(() => {
          setOpen(false);
        });

    } else if(docType === "Policy") {
      const file = files[0];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!policyFormats.includes(fileExtension)) {
        toast.error("Please upload Policy Document in PDF format only.");
        setOpen(false);
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        const base64string = reader.result.split(",")[1];
        setCattleVal((prevState) => ({
          ...prevState,
          imageFormatPolicy: fileExtension,
          imageBase64Policy: base64string,
        }));
        toast.success(`${docType} Document Uploaded Successfully.`);
      };
      reader.readAsDataURL(file);
    }
    else {
      const file = files[0];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!coverFormats.includes(fileExtension)) {
        toast.error("Please upload Cover Letter in PDF format only.");
        setOpen(false);
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        const base64string = reader.result.split(",")[1];
        setCattleVal((prevState) => ({
          ...prevState,
          imageFormatCover: fileExtension,
          imageBase64Cover: base64string,
        }));
        toast.success(`${docType} Document Uploaded Successfully.`);
      };
      reader.readAsDataURL(file);
    }
  };

  const initialCattleState = {
    srNo: "",
    NoOfCattle: "",
    TypeofCattle: "",
    Breed: "",
    SumAssured: "",
    RiskStartDate: "",
    RiskEndDate: "",
    RFIDNo: "",
    PolicyNo: "",
    imageFormatPolicy: "",
    imageBase64Policy: "",
    imageFormatCover: "",
    imageBase64Cover: "",
    cattleImages: [],
  };

  const addFieldHandler = async () => {
    setOpen(true);
    const request = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      loanId: loanId,
      srNo: isUpdateActive ? cattleVal.srNo : cattleCount,
      NoOfCattle: cattleVal.NoOfCattle,
      TypeofCattle: cattleVal.TypeofCattle,
      Breed: cattleVal.Breed,
      SumAssured: cattleVal.SumAssured,
      RiskStartDate: cattleVal.RiskStartDate,
      RiskEndDate: cattleVal.RiskEndDate,
      RFIDNo: cattleVal.RFIDNo,
      PolicyNo: cattleVal.PolicyNo,
      docTypePolicy: cattleVal.imageFormatPolicy,
      chequeDataPolicy: cattleVal.imageBase64Policy,
      docTypeCover: cattleVal.imageFormatCover,
      chequeDataCover: cattleVal.imageBase64Cover,
      cattleImages: cattleVal.cattleImages,
    };
    try {
      let res;
      if (isUpdateActive) {
        res = await axios.post(url + "/loan/update/cattle/data", request);
      } else {
        res = await axios.post(url + "/loan/add/cattle/data", request);
      }

      if (res.data.auth === true) {
        setOpen(false);
        toast.success(res.data.message);
      } else {
        setOpen(false);
        toast.error(res.data.message);
      }
      await fetchData();
      setCattleVal(initialCattleState);
      setIsUpdateActive(false);
    } catch (err) {
      setOpen(false);
      console.log(err.response.data);
      toast.error(err.response.data.message);
    }
  };

  const deleteFileHandler = async (id, policy, cover, cattle) => {
    const cattleData = window.confirm("Do you want to Delete the Cattle Insurance Data?");
    if (cattleData) {
      setOpen(true);
      const request = {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        loanId: loanId,
        srNo: id,
        borrower_uniqueno: localStorage.getItem("uniqueID"),
        docTypePolicy: policy,
        docTypeCover: cover,
        docTypeCattle: cattle
      };

      try {
        const { data } = await axios.post(url + "/loan/delete/cattle/data", request);

        if (data.auth === true) {
          setOpen(false);
          toast.success(data.message);
        } else {
          setOpen(false);
          toast.error(data.message);
        }
        await fetchData();
        setCattleVal(initialCattleState);
      } catch (error) {
        setOpen(false);
        console.log(error.response.data);
        toast.error(error.response.data.message);
      }
    }
    else {
      setOpen(false);
      toast.error("Permission Denied by the user.");
    }
  };

  const editFileHandler = async (field) => {
    // console.log(field);
    setIsUpdateActive(true);
    setCattleVal({
      srNo: field.srNo,
      NoOfCattle: field.NoOfCattle,
      TypeofCattle: field.TypeofCattle,
      Breed: field.Breed,
      SumAssured: field.SumAssured,
      RiskStartDate: field.RiskStartDate,
      RiskEndDate: field.RiskEndDate,
      RFIDNo: field.RFIDNo,
      PolicyNo: field.PolicyNo,
      imageFormatPolicy: field.imageFormatPolicy,
      imageBase64Policy: field.imageBase64Policy,
      imageFormatCover: field.imageFormatCover,
      imageBase64Cover: field.imageBase64Cover,
      cattleImages: [],
    });
  };

  const handleViewImage = async (key, format) => {
    setOpen(true);
    try {
      const { data } = await axios.post(url + "/loan/view/document", {
        key: key,
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
      })
      if (data.auth) {
        setOpen(false);
        // console.log(data, "data of base64")
        setPreviewModal(true)
        setBase64Image(data.base64);
        setDocType(format)
      }
    } catch (error) {
      setOpen(false);
      console.log(error)
    }
  };

  const handleMultiDocs = async (data) => {
    setParentModal(true)
    setCattleData(data)
  }

  const downloadFileHandler = async (key, format) => {
    setOpen(true);
    try {
      const { data } = await axios.post(url + "/loan/view/document", {
        key: key,
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
      });

      if (data.auth) {
        setOpen(false);
        // console.log(data, "data of base64");
        downloadFile(format, data.base64);
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
    }
  };

  const downloadFile = (format, base64) => {
    let mimeType;
    if (format.toLowerCase() === "pdf") {
      mimeType = "application/pdf";
    } else {
      mimeType = `image/${format.toLowerCase()}`;
    }
    const linkSource = `data:${mimeType};base64,${base64}`;
    const downloadLink = document.createElement("a");
    const fileName = `Cattle_Insurance.${format}`;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const handleDateChange = (e, fieldName) => {
    const { value } = e.target;
    setCattleVal((prevState) => ({
      ...prevState,
      [fieldName]: formatDateToDDMMYYYY(value)
    }));
  };

  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("/");
    return `${year}-${month}-${day}`;
  };

  const handleClosePreview = () => {
    setPreviewModal(false);
    setBase64Image("")
  };

  return (
    <section>
      <div className={styles.pdcModal}>
        <div className={styles.pdcModalOverlay}>
          <div className={styles.pdcModalContent}>
            <div className={styles.topBar}>
              <div>
                <h2>Cattle Insurance Details</h2>
              </div>
              <CloseIcon className={styles.CloseIcon} onClick={closeModal} />
            </div>
            <div className={styles.tableDiv}>
              <table className={styles.customTable}>
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>No of Cattle</th>
                    <th>Type of Cattle</th>
                    <th>Breed</th>
                    <th>Sum Assured</th>
                    <th>Risk Start Date</th>
                    <th>Risk End Date</th>
                    <th>RFID No</th>
                    <th>Policy Number</th>
                    <th>Upload Policy Copy</th>
                    <th>Upload Cover Letter</th>
                    <th>Upload Cattle Images</th>
                    <th>Actions</th>
                  </tr>
                  {cattleArr?.length > 0
                    ? cattleArr.map((field, index) => {
                      return (
                        <tr key={field.srNo}>
                          <td>{field.srNo}</td>
                          <td>{field.NoOfCattle}</td>
                          <td>{field.TypeofCattle}</td>
                          <td>{field.Breed}</td>
                          <td>{field.SumAssured}</td>
                          <td>{field.RiskStartDate}</td>
                          <td>{field.RiskEndDate}</td>
                          <td>{field.RFIDNo}</td>
                          <td>{field.PolicyNo}</td>
                          <td>
                            <div className={styles.actions}>
                              <Tooltip title="View Document">
                                <button
                                  className={styles.upload}
                                  onClick={() =>
                                    handleViewImage(
                                      field.cattleKeyPolicy,
                                      field.cattleDocTypePolicy
                                    )
                                  }
                                >
                                  View
                                </button>
                              </Tooltip>
                              <Tooltip title="Download Document">
                                <p
                                  onClick={() =>
                                    downloadFileHandler(
                                      field.cattleKeyPolicy,
                                      field.cattleDocTypePolicy
                                    )
                                  }
                                >
                                  <IoMdDownload
                                    size={24}
                                    color="rgba(0, 94, 202, 0.952)"
                                    cursor={"pointer"}
                                  />
                                </p>
                              </Tooltip>
                            </div>
                          </td>
                          <td>
                            <div className={styles.actions}>
                              <Tooltip title="View Document">
                                <button
                                  className={styles.upload}
                                  onClick={() =>
                                    handleViewImage(
                                      field.coverKey,
                                      field.coverDocType
                                    )
                                  }
                                >
                                  View
                                </button>
                              </Tooltip>
                              <Tooltip title="Download Document">
                                <p
                                  onClick={() =>
                                    downloadFileHandler(
                                      field.coverKey,
                                      field.coverDocType
                                    )
                                  }
                                >
                                  <IoMdDownload
                                    size={24}
                                    color="rgba(0, 94, 202, 0.952)"
                                    cursor={"pointer"}
                                  />
                                </p>
                              </Tooltip>
                            </div>
                          </td>
                          <td>
                            <div className={styles.actions}>
                              {field.cattle_images && field.cattle_images.length > 0 ? (
                                <Tooltip title="View Document">
                                  <button
                                    className={styles.upload}
                                    onClick={() => handleMultiDocs(field.cattle_images)}
                                  >
                                    View
                                  </button>
                                </Tooltip>
                              ) : (
                                <span style={{ color: 'gray', fontStyle: 'italic' }}>
                                  No Document Found
                                </span>
                              )}
                            </div>

                          </td>
                          <td>
                            <div className={styles.actions}>
                              <Tooltip title="Delete">
                                <p onClick={() => deleteFileHandler(field.srNo, field.docTypePolicy, field.docTypeCover, field.docTypeCattle)}>
                                  <MdDeleteForever
                                    size={24}
                                    color="red"
                                    cursor={"pointer"}
                                  />
                                </p>
                              </Tooltip>
                              <Tooltip title="Edit">
                                <p onClick={() => editFileHandler(field)}>
                                  <EditIcon
                                    size={24}
                                    color="gray"
                                    cursor={"pointer"}
                                  />
                                </p>
                              </Tooltip>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                    : null}
                  <tr>
                    <td>{isUpdateActive === true ? cattleVal.srNo : cattleCount}</td>
                    <td>
                      <input
                        className={styles.inputStyle}
                        type="number"
                        value={cattleVal.NoOfCattle}
                        onChange={handleInputChange("NoOfCattle")}
                      />
                    </td>
                    <td>
                      <select
                        className={styles.inputStyle}
                        onChange={handleInputChange("TypeofCattle")}
                        name=""
                        id=""
                        value={cattleVal.TypeofCattle}
                      >
                        <option value="">Select</option>
                        <option value="Cow">Cow</option>
                        <option value="Buffalo">Buffalo</option>
                      </select>
                    </td>
                    <td>
                      <select
                        className={styles.inputStyle}
                        onChange={handleInputChange("Breed")}
                        name=""
                        id=""
                        value={cattleVal.Breed}
                      >
                        <option value="">Select</option>
                        <option value="Murrah">Murrah</option>
                        <option value="HF">HF</option>
                        <option value="Indigenous">Indigenous</option>
                        <option value="Crossbreed">Crossbreed</option>
                      </select>
                    </td>
                    <td>
                      <input
                        className={styles.inputStyle}
                        type="number"
                        onChange={handleInputChange("SumAssured")}
                        value={cattleVal.SumAssured}
                      />
                    </td>
                    <td>
                      <input
                        className={styles.inputStyle}
                        type="date"
                        onChange={(e) => handleDateChange(e, "RiskStartDate")}
                        value={formatDateForInput(cattleVal.RiskStartDate)}
                        inputProps={{
                         max: new Date().toISOString().split("T")[0],
                        }}
                      />
                    </td>
                    <td>
                      <input
                        className={styles.inputStyle}
                        type="date"
                        onChange={(e) => handleDateChange(e, "RiskEndDate")}
                        value={formatDateForInput(cattleVal.RiskEndDate)}
                        inputProps={{
                         max: new Date().toISOString().split("T")[0],
                        }}
                      />
                    </td>

                    <td>
                      <input
                        className={styles.inputStyle}
                        type="text"
                        onChange={handleInputChange("RFIDNo")}
                        value={cattleVal.RFIDNo}
                      />
                    </td>
                    <td>
                      <input
                        className={styles.inputStyle}
                        type="text"
                        onChange={handleInputChange("PolicyNo")}
                        value={cattleVal.PolicyNo}
                      />
                    </td>
                    <td>
                      <input
                        onChange={(e) => handleImageUpload(e, "Policy")}
                        type="file"
                        ref={policyRef}
                        style={{ display: "none" }}
                      />
                      <button
                        className={styles.upload}
                        onClick={() => {
                          policyRef.current.value = null;
                          policyRef.current.click();
                        }}
                      >
                        {isUpdateActive === true ? "Upload New Doc" : "Upload"}
                      </button>
                    </td>
                    <td>
                      <input
                        onChange={(e) => handleImageUpload(e, "Cover")}
                        type="file"
                        ref={coverRef}
                        style={{ display: "none" }}
                      />
                      <button
                        className={styles.upload}
                        onClick={() => {
                          coverRef.current.value = null;
                          coverRef.current.click();
                        }}
                      >
                        {isUpdateActive === true ? "Upload New Doc" : "Upload"}
                      </button>
                    </td>
                    <td>
                      <input
                        onChange={(e) => handleImageUpload(e, "Cattle")}
                        type="file"
                        ref={cattleRef}
                        style={{ display: "none" }}
                        multiple
                      />
                      <button
                        className={styles.upload}
                        onClick={() => {
                          cattleRef.current.value = null;
                          cattleRef.current.click();
                        }}
                      >
                        {isUpdateActive === true ? "Upload New Doc" : "Upload"}
                      </button>
                    </td>
                    <td>
                      <button className={styles.add} onClick={addFieldHandler}>
                        {isUpdateActive === true ? "Update" : "ADD"}
                      </button>
                    </td>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
      <PreviewModal open={previewModal} onClose={handleClosePreview} fileSrc={base64Image} fileType={docType} />
      <MultiViewModal 
        open={parentModal}
        data={cattleData}
        close={() => setParentModal(false)}
        loanId={loanId}
        onDelete={onDelete}
        dbKey="cattleKeyCattle"
        dbDocType="cattleDocTypeCattle"
        docName="Cattle Insurance"
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </section>
  );
};

export default CattleModal;

